export const list = {
  table: {
    title: '水洗機部品',
    id: 'ID',
    name: '水洗機部品名',
    totalTimeUsed: '洗浄耐用回数',
    totalLife: 'アラート回数',
    usedTime: '総洗浄回数',
    timeLeftToChange: 'アラート回数',
    changedDate: '交換日',
    complete: '交換完了',
    detail: '詳細',
    unit: '回',
    success: '水洗機部品の交換に成功しました。',
    error: '水洗機部品の交換に失敗しました。',
    deleteSuccess: '削除に成功しました',
    deleteError: '削除に失敗しました',
  },
  recentHistory: {
    title: '最近の変更履歴',
    id: 'ID',
    name: '部品名',
    usedTime: '洗浄耐用回数',
    changedDate: '交換日',
  },
  modal: {
    id: 'ID',
    usedTime: '洗浄耐用回数',
    changedDate: '交換日',
    title: '水洗機部品詳細',
  },
  pageHeader: {
    title: '水洗機リスト　水洗機詳細画面',
    titleMachinePartsList: '個人データ登録/編集',
    new: '新規',
  },
}
